import {AjaxForm} from "../../../assets/js/components/forms/AjaxForm";

export const initComponentNewsletterForm = () => {
    [...document.querySelectorAll('form.c-newsletter-form:not(.-initialized)')].map(item => new AjaxForm(item));
}